<app-dialog [dialogTitle]="title">
  <app-dialog-content>{{ message }}</app-dialog-content>
  <app-dialog-actions>
    <app-button [variant]="cancelButtonVariant" [mat-dialog-close]="false">
      {{ cancelButtonText || 'public.global.no' | translate }}
    </app-button>
    <app-button [variant]="confirmButtonVariant" [mat-dialog-close]="true">
      {{ confirmButtonText || ('public.global.yes' | translate) }}
    </app-button>
  </app-dialog-actions>
</app-dialog>
